// src/pages/AppDashboard.js
import { React, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from "../context/UserContext";
import JWTService from '../services/JWTService';
import ChallengeCard from './components/challenge/ChallengeCard';
import Loading from './common/Loading';
import { ArrowLeft, Settings, Text } from "lucide-react"
import instance from '../api/axiosConfig';
import Firework from './common/Firework'
import NewChallenge from './components/challenge/NewChallenge';
import Swal from 'sweetalert2'
import Modal from 'react-modal';

import BuildSystemInfo from './../data/BuildSystemInfo'

const Challenges = () => {
  const navigate = useNavigate();

  const { user, loginUser } = useUser(); // Use context
  const [challenges, setChallenges] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showFirework, setShowFirework] = useState(false);


  const [isModalOpen, setIsModalOpen] = useState(false); // Thêm trạng thái cho modal

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false)
  };

  useEffect(() => {
    if (!user || (user && JWTService.isTokenExpired(user.token))) navigate("/login");

  })

  // Fetch challenges from the backend API
  const fetchChallenges = async () => {
    try {
      setIsLoading(true)
      const response = await instance.get('/challenge/getallbyuser?userId=' + user.guid); // Replace with your API endpoint
      setChallenges(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching challenges:', error);
    }
  };

  useEffect(() => {


    fetchChallenges();
  }, []);

  const handleComplete = async (challengeId) => {
    let data = {
      challengeId: challengeId,
      userId: user.guid
    }
    try {
      const responseData = await instance.put(`/challenge/markcompleted`, data); // Replace with your API endpoint
      setShowFirework(true); // Show firework on completion
      var timer = setTimeout(() => setShowFirework(false), 10000); // Hide firework after 5 seconds
      clearTimeout(timer)
    } catch (error) {
      console.error('Error fetching items:', error);
    }
    fetchChallenges();
  };

  const onDeleteChallenge = (challengeId) => {

    //confirm delete
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "danger",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const responseData = await instance.delete(`/challenge?ChallengeId=${challengeId}&userId=${user.guid}`); // Replace with your API endpoint
          Swal.fire({
            title: "Deleted!",
            text: "Item has been deleted.",
            icon: "success"
          });
        } catch (error) {
          console.error('Error fetching items:', error);
        }
        fetchChallenges();

      }
    });


  };

  return (
    <div className="container mx-auto p-6">
      <div className="flex items-center justify-between mb-6">
        <Link to="/" className="inline-flex items-center text-gray-600 mb-4">
          <ArrowLeft className="w-5 h-5 mr-1" />
          BACK
        </Link>

        <div>
          <p className="text-gray-600 center">Welcome {user && user.name}</p>
          <h1 className="text-2xl font-bold">
            Your Challenges
            <span className="inline-block ml-1 border-b-2 border-red-500"></span>
          </h1>
        </div>
        <Link to="/app/settings">
          <Settings className="w-6 h-6 text-gray-600" />
        </Link>
      </div>
      {showFirework && <Firework run={showFirework} />}
      {
        isLoading ? <Loading /> : <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <button
              onClick={openModal}
              className='bg-white rounded-xl shadow-sm border p-4 mb-4 flex items-center justify-center min-h-50'
            >
              <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 mb-2">
                <span className="text-xl ">+</span>
              </div>
            </button>


            {challenges.map((challenge) => (
              <ChallengeCard key={challenge.id} challenge={challenge} onComplete={handleComplete} onDelete={onDeleteChallenge} />
            ))}
          </div>
        </>
      }


      <div className="text-center mt-8">
        <a href={`mailto:${BuildSystemInfo.email}`} className="text-gray-600 underline text-sm">
          Feedback?
        </a>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="bg-white p-6 rounded shadow-lg mx-auto mt-20"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
      >
        <NewChallenge closeModal={closeModal} fetchChallenges={fetchChallenges} />
      </Modal>
    </div>
  );
};

export default Challenges;